export const VehicleConstant = {
  VEHICLE_SAGA: "VEHICLE_SAGA",
  VEHICLE_REQUEST: "VEHICLE_REQUEST",
  VEHICLE_RESPONSE: "VEHICLE_RESPONSE",
  VEHICLE_API: "/vehicles",

  ADD_VEHICLE_SAGA: "ADD_VEHICLE_SAGA",
  ADD_VEHICLE_REQUEST: "ADD_VEHICLE_REQUEST",
  ADD_VEHICLE_RESPONSE: "ADD_VEHICLE_RESPONSE",
  ADD_VEHICLE_API: "/add-vehicle",
  
  VEHICLE_DROPDOWN_SAGA: "VEHICLE_DROPDOWN_SAGA",
  VEHICLE_DROPDOWN_REQUEST: "VEHICLE_DROPDOWN_REQUEST",
  VEHICLE_DROPDOWN_RESPONSE: "VEHICLE_DROPDOWN_RESPONSE",
  VEHICLE_DROPDOWN_API: "/dropdowns",

  POST_VEHICLE_BULK_SAGA: "POST_VEHICLE_BULK_SAGA",
  POST_VEHICLE_BULK_REQUEST: "POST_VEHICLE_BULK_REQUEST",
  POST_VEHICLE_BULK_RESPONSE: "POST_VEHICLE_BULK_RESPONSE",
  POST_VEHICLE_BULK_API: "/bulk",

 VEHICLE_TYPES_SAGA: "VEHICLE_TYPES_SAGA",
  VEHICLE_TYPES_REQUEST: "VEHICLE_TYPES_REQUEST",
  VEHICLE_TYPES_RESPONSE: "VEHICLE_TYPES_RESPONSE",
  VEHICLE_TYPES_API: "/vehicle-types-dropdowns",

  VEHICLE_SUB_TYPES_SAGA: "VEHICLE_SUB_TYPES_SAGA",
  VEHICLE_SUB_TYPES_REQUEST: "VEHICLE_SUB_TYPES_REQUEST",
  VEHICLE_SUB_TYPES_RESPONSE: "VEHICLE_SUB_TYPES_RESPONSE",
  VEHICLE_SUB_TYPES_API: "/sub-types-dropdowns",
  
  VEHICLE_MODEL_SAGA: "VEHICLE_MODEL_SAGA",
  VEHICLE_MODEL_REQUEST: "VEHICLE_MODEL_REQUEST",
  VEHICLE_MODEL_RESPONSE: "VEHICLE_MODEL_RESPONSE",
  VEHICLE_MODEL_API: "/common/get-vehicle-models",

  VEHICLE_GET_MENUFATURER_SAGA: "VEHICLE_GET_MENUFATURER_SAGA",
  VEHICLE_GET_MENUFATURER_REQUEST: "VEHICLE_GET_MENUFATURER_REQUEST",
  VEHICLE_GET_MENUFATURER_RESPONSE: "VEHICLE_GET_MENUFATURER_RESPONSE",
  VEHICLE_GET_MENUFATURER_API: "/manufacture-dropdowns",

  VEHICLE_VARIANT_DROPDOWN_SAGA: "VEHICLE_VARIANT_DROPDOWN_SAGA",
  VEHICLE_VARIANT_DROPDOWN_REQUEST: "VEHICLE_VARIANT_DROPDOWN_REQUEST",
  VEHICLE_VARIANT_DROPDOWN_RESPONSE: "VEHICLE_VARIANT_DROPDOWN_RESPONSE",
  VEHICLE_VARIANT_DROPDOWN_API: "/get-variants",

  DELETE_VEHICLE_API: "/delete-vehicle/:id",

  UPDATE_VEHICLE_API:"/edit-vehicle/:id"


}